var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DeleteProductModal',_vm._g({attrs:{"product-id":_vm.serviceId,"deleting":_vm.deleting}},{ submit: _vm.handleProductDelete }))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }